module.exports = __webpack_public_path__ + "static/fogler-rubinoff-logo-1b6950688730a66aa6202637a6041db9.png";